import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Popper } from "@material-ui/core";
import { Clear } from "@material-ui/icons";
import { StyledCompProps } from "../../../../globalTypes/theme";
import { ThemedCssCreator } from "../../../../config/emotion";

export const moreEntriesButtonCss: ThemedCssCreator = (theme) => css`
  width: 100%;
  text-align: center;
  padding: 5px 10px;
  border: 1px solid #c0c6d0;
  color: #c0c6d0;
  border-radius: 24px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 13px;
  position: relative;

  &:hover {
    border: 1px solid ${theme.colors.secondaryColor};
    color: ${theme.colors.secondaryColor};
  }
`;

export const entitiesContainerCss: ThemedCssCreator = (theme) => css`
  width: auto;
  min-width: 150px;
  padding: 5px 10px;
  //border: 1px solid ${theme.colors.bgColor};
  box-shadow: 0 0 1px 1px #c0c6d0;
  color: #c0c6d0;
  border-radius: 12px;
  background-color: #ffffff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
`;

type EntityContainerProps = StyledCompProps & { edit: boolean };
export const EntityContainer = styled.div<EntityContainerProps>`
  padding: 2.5px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => `border-bottom: 1px solid ${theme.colors.bgColor};`}

  &:last-child {
    border-bottom: none;
  }
`;

export const ClearIcon = styled(Clear)<StyledCompProps>`
  font-size: 15px !important;
  color: ${({ theme }) => theme.colors.secondaryColor};
  cursor: pointer;
  margin-left: 5px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.bgColor};
    border-radius: 50%;
  }
`;

export const noStyledButton: ThemedCssCreator = (theme) => css`
  border: none;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5px;

  &:hover {
    background-color: ${theme.colors.bgColor};
    border-radius: 50%;
  }
`;

export const alignSelfCss = css`
  align-self: flex-end;
`;

export const StyledPopper = styled(Popper)`
  z-index: 1060;
  margin-top: 5px;
`;
